// extracted by mini-css-extract-plugin
export var container = "trailText-module--container--VDNTe";
export var innerText = "trailText-module--innerText--BKpXw";
export var outerTextBox = "trailText-module--outerTextBox--q4RQ3";
export var outlineText = "trailText-module--outlineText--pQnGZ";
export var showText = "trailText-module--showText--IbBhU";